import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9876c788"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-max-w-[800px] lg:tw-w-[800px] tw-w-auto" }
const _hoisted_2 = {
  key: 0,
  class: "tw-bg-[#FEE5E2] tw-px-[12px] tw-py-[8px] tw-mx-[25px] tw-flex tw-items-center tw-mt-[25px] tw-rounded-[6px] tw-gap-[10px]"
}
const _hoisted_3 = { class: "tw-text-[#F7553C] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-center tw-mb-[0px]" }
const _hoisted_4 = { class: "tw-flex tw-leading-[100%] tw-justify-between tw-gap-[20px] tw-bg-[#ffffff] tw-rounded-b-md tw-border-[1px] tw-border-t-0 tw-border-solid tw-border-[#EFF0F1] tw-p-[25px]" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-w-[100%] tw-gap-[20px]" }
const _hoisted_6 = { class: "tw-mb-0 tw-text-[13px] tw-text-[#231F20] tw-leading-[145%] tw-font-medium tw-font-Poppins" }
const _hoisted_7 = { class: "dropdown" }

import { ensurePeriod, getComponentUiText } from "@/utils/utilities";
import ContentHeaderComponent from "./contentHeaderComponent.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import BaseDropDown from "../common/form/baseDropDown.vue";
import store from "@/store";
import { computed, ref, watch } from "vue";
import { IWizardPageQuestion } from "@/interfaces/wizard";
import {
  WIZARD_STATE_NAME,
  WIZARD_STATE_QUESTION_TYPE_ID,
} from "@/utils/constants";
import { generateQuestionDataPage } from "@/services/wizard";
import WarningIcon from "../svgs/warningIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'orgsPage',
  props: {
  isApiError: {
    type: Boolean,
    required: false,
    default: false,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: null,
      errorMessage: "",
    }),
  },
},
  emits: ["check:select"],
  setup(__props, { emit: emits }) {

const props = __props;


const apiError = ref(false);
watch(
  () => props.isApiError,
  (newValue) => {
    apiError.value = newValue;
  },
  { immediate: true },
);

const orgsPageQuestion: IWizardPageQuestion[] = [
  {
    id: WIZARD_STATE_QUESTION_TYPE_ID.LIFECYCLE,
    valueId: WIZARD_STATE_QUESTION_TYPE_ID.LIFECYCLE + "Id",
    title: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-org-questions-lifecycle-title-1",
    ),
    typeId: WIZARD_STATE_QUESTION_TYPE_ID.LIFECYCLE,
    QuestionOptions: [] as IDropDownData[],
    values: [""],
  },
  {
    id: WIZARD_STATE_QUESTION_TYPE_ID.INDUSTRY,
    valueId: WIZARD_STATE_QUESTION_TYPE_ID.INDUSTRY + "Id",

    title: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-org-questions-industry-title-1",
    ),
    typeId: WIZARD_STATE_QUESTION_TYPE_ID.INDUSTRY,
    QuestionOptions: [] as IDropDownData[],
    values: [""],
  },
  {
    id: WIZARD_STATE_QUESTION_TYPE_ID.MARKET,
    valueId: WIZARD_STATE_QUESTION_TYPE_ID.MARKET + "Id",

    title: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-org-questions-market-title-1",
    ),
    typeId: WIZARD_STATE_QUESTION_TYPE_ID.MARKET,
    QuestionOptions: [] as IDropDownData[],
    values: [""],
  },
  {
    id: WIZARD_STATE_QUESTION_TYPE_ID.REVENUE,
    valueId: WIZARD_STATE_QUESTION_TYPE_ID.REVENUE + "BandId",
    title: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-org-questions-revenue-title-1",
    ),
    typeId: WIZARD_STATE_QUESTION_TYPE_ID.REVENUE,
    QuestionOptions: [] as IDropDownData[],
    values: [""],
  },
];

const currentOrg = computed(() => store.state.Org.currentOrg);
const questionSectionValue = computed(() =>
  store.getters["SetupWizard/getQuestionsBySection"](
    WIZARD_STATE_NAME.ORG,
    currentOrg.value.id || null,
  ),
);

const questionData = computed(() => {
  const value = generateQuestionDataPage(
    orgsPageQuestion,
    questionSectionValue.value,
  );

  return value;
});



const selectValue = (value, question: IWizardPageQuestion) => {
  apiError.value = false;
  store.dispatch("SetupWizard/updateQuestions", {
    value: { [question.valueId]: value },
    orgId: currentOrg.value.id || null,
    typeId: question.typeId,
    page: WIZARD_STATE_NAME.ORG,
  });

  store.commit("SetupWizard/SET_SELECT", value);
  emits("check:select", value);
};

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ContentHeaderComponent, {
      title: 
        _unref(getComponentUiText)(
          'app-menu-submenu-home-setup-wizard-modal-orgs-title-1',
        )
      ,
      "sub-title": 
        _unref(getComponentUiText)(
          'app-menu-submenu-home-setup-wizard-modal-orgs-sub-title-1',
        )
      
    }, null, 8, ["title", "sub-title"]),
    (__props.isApiError && __props.statusInPage.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(WarningIcon, { color: "#F7553C" }),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
            "app-component-wizards-setup-error-tooltip",
            false,
            {
              errorMessage: __props.statusInPage.errorMessage
                ? _unref(ensurePeriod)(__props.statusInPage.errorMessage)
                : "",
            },
          )), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionData.value, (question, index) => {
          return (_openBlock(), _createBlock(_component_b_row, {
            key: index,
            class: _normalizeClass('row-container tw-flex tw-flex-row tw-gap-[40px] tw-mr-0 tw-ml-0')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, {
                class: _normalizeClass('tw-pr-0 tw-pl-0 tw-flex tw-items-center')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("label", _hoisted_6, _toDisplayString(question.title), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_b_col, {
                class: _normalizeClass('col-sm-6 tw-pr-0 tw-pl-0')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(BaseDropDown, {
                      id: 'goals-dropdown-' + index,
                      data: question.QuestionOptions || [],
                      validation: {},
                      "model-value": 
                  question.values.length > 0
                    ? question.values[question.values.length - 1][
                        question.valueId
                      ]
                    : []
                ,
                      "border-select": true,
                      "class-name": 'gray-dropdown-container tw-h-[56px]',
                      class: _normalizeClass(`${
                  !Boolean(question.values[question.values.length - 1]?.id) &&
                  apiError.value &&
                  question.values.length !== 0
                    ? 'error'
                    : ''
                }`),
                      "use-visual-scroll": false,
                      "onUpdate:modelValue": ($event: any) => (selectValue($event, question))
                    }, null, 8, ["id", "data", "model-value", "class", "onUpdate:modelValue"])
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ])
  ]))
}
}

})